import axios from 'axios';
import Cookies from 'universal-cookie';

const initialState = {
    packages: [],
};

// Action Types
const GET_PACKAGES = 'GET_PACKAGES';
const POST_PACKAGE = 'POST_PACKAGE';
const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
const DELETE_PACKAGE = 'DELETE_PACKAGE';

// Reducer
export default function TokenPackagesReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PACKAGES:
            return { ...state, packages: action.payload };
        case POST_PACKAGE:
            return { ...state, packages: [...state.packages, action.payload] };
        case UPDATE_PACKAGE:
            return {
                ...state,
                packages: state.packages.map(p =>
                    p.id === action.payload.id ? { ...p, ...action.payload } : p
                ),
            };
        case DELETE_PACKAGE:
            return {
                ...state,
                packages: state.packages.map(p =>
                    p.id === action.payload ? { ...p, active: false } : p
                ),
            };
        default:
            return state;
    }
}

// Action Creators
export const SetPackages = (packages) => ({ type: GET_PACKAGES, payload: packages });
export const PostPackage = (pkg) => ({ type: POST_PACKAGE, payload: pkg });
export const UpdatePackage = (pkg) => ({ type: UPDATE_PACKAGE, payload: pkg });
export const DeletePackage = (id) => ({ type: DELETE_PACKAGE, payload: id });

const getHeaders = () => {
    const cookies = new Cookies();
    return { headers: { Authorization: `Bearer ${cookies.get('token')}` } };
};

// Thunks (proxy /api/admin/token-packages en EasyLawyer → SDK Billing)
export const fetchPackagesFromAPI = () => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/admin/token-packages', getHeaders());
        dispatch(SetPackages(response.data));
    } catch (error) {
        console.error('Error fetching token packages:', error);
    }
};

export const createPackageInAPI = (pkg) => async (dispatch) => {
    try {
        const response = await axios.post(window.API_BASE_URL + '/admin/token-packages', pkg, getHeaders());
        dispatch(PostPackage(response.data));
    } catch (error) {
        console.error('Error creating token package:', error);
    }
};

export const updatePackageInAPI = (id, pkg) => async (dispatch) => {
    try {
        const response = await axios.put(`${window.API_BASE_URL}/admin/token-packages/${id}`, pkg, getHeaders());
        dispatch(UpdatePackage(response.data));
    } catch (error) {
        console.error('Error updating token package:', error);
    }
};

export const deletePackageFromAPI = (id) => async (dispatch) => {
    try {
        await axios.delete(`${window.API_BASE_URL}/admin/token-packages/${id}`, getHeaders());
        dispatch(DeletePackage(id));
    } catch (error) {
        console.error('Error deleting token package:', error);
    }
};
